import type { TourStep } from '../types';
import { designerCreateSteps } from './createSteps';
import { designerStatsSteps } from './statsSteps';
import { designerPayoutsSteps } from './payoutsSteps';
import { designerTariffsSteps } from './tariffsSteps';

const onPage = (steps: TourStep[], navigateTo: string): TourStep[] =>
  steps.map((step) => ({ ...step, navigateTo }));

export const designerCabinetSteps: TourStep[] = [
  { target: 'body', title: 'Экскурсия по кабинету', content: 'Пройдём по всем разделам личного кабинета.', placement: 'center', navigateTo: '/designer/create' },
  ...onPage(designerCreateSteps, '/designer/create'),
  ...onPage(designerStatsSteps, '/designer/stats'),
  ...onPage(designerPayoutsSteps, '/designer/payouts'),
  ...onPage(designerTariffsSteps, '/designer/tariffs'),
  { target: 'body', title: 'Готово', content: 'Теперь вы знаете, где создавать макеты, смотреть статистику, выплаты и тарифы.', placement: 'center', navigateTo: '/designer/create' },
];
